import { createSagaAction } from '../../shared/sagas'
import { createReducer } from '../../shared/reducers'

// Constants
export const constants = {
  GET_ALL_ITEMS: createSagaAction('GET_ALL_ITEMS'),
  CREATE_NEW_ITEM: createSagaAction('CREATE_NEW_ITEM'),
  UPDATE_SAVED_ITEM: createSagaAction('UPDATE_SAVED_ITEM'),
  DELETE_ITEM: createSagaAction('DELETE_ITEM'),
  GET_ITEM_IMAGES: createSagaAction('GET_ITEM_IMAGES'),
  SAVE_ITEM_IMAGE: createSagaAction('SAVE_ITEM_IMAGE'),
  DELETE_ITEM_IMAGE: createSagaAction('DELETE_ITEM_IMAGE'),

  PRINT_ITEMS: createSagaAction('PRINT_ITEMS'),

  GET_VENDOR_ITEMS: createSagaAction('GET_VENDOR_ITEMS'),
  GET_ITEM_VENDORS: createSagaAction('GET_ITEM_VENDORS'),

  CREATE_NEW_ITEM_VENDOR: createSagaAction('CREATE_NEW_ITEM_VENDOR'),
  DELETE_ITEM_VENDOR: createSagaAction('DELETE_ITEM_VENDOR'),

  // notes
  GET_ITEM_NOTE: createSagaAction('GET_ITEM_NOTE'),
  CREATE_ITEM_NOTE: createSagaAction('CREATE_ITEM_NOTE'),
  EDIT_ITEM_NOTE: createSagaAction('EDIT_ITEM_NOTE'),
  DELETE_ITEM_NOTE: createSagaAction('DELETE_ITEM_NOTE')
}

// Action Creators
export const actions = {
  itemsRefresh: () => ({ type: constants.GET_ALL_ITEMS.ACTION }),
  createNewItem: ({ item, userId, fileList }) => ({
    type: constants.CREATE_NEW_ITEM.ACTION,
    item,
    userId,
    fileList
  }),
  createItemVendor: ({ itemVendorPayload }) => ({
    type: constants.CREATE_NEW_ITEM_VENDOR.ACTION,
    itemVendorPayload
  }),
  deleteItemVendor: ({ itemVendorPayload }) => ({
    type: constants.DELETE_ITEM_VENDOR.ACTION,
    itemVendorPayload
  }),
  updateSavedItem: itemInfo => ({
    type: constants.UPDATE_SAVED_ITEM.ACTION,
    ...itemInfo
  }),
  deleteItem: ({ itemId }) => ({
    type: constants.DELETE_ITEM.ACTION,
    itemId
  }),
  printItems: queryString => ({
    type: constants.PRINT_ITEMS.ACTION,
    queryString
  }),
  getItemImages: ({ itemId }) => ({
    type: constants.GET_ITEM_IMAGES.ACTION,
    itemId
  }),
  getItemVendors: ({ itemId }) => ({
    type: constants.GET_ITEM_VENDORS.ACTION,
    itemId
  }),
  saveItemImage: ({ itemId, image }) => ({
    type: constants.SAVE_ITEM_IMAGE.ACTION,
    itemId,
    image
  }),

  deleteItemImage: ({ imageId, itemId }) => ({
    type: constants.DELETE_ITEM_IMAGE.ACTION,
    imageId,
    itemId
  }),

  getVendorItems: ({ vendorId }) => ({
    type: constants.GET_VENDOR_ITEMS.ACTION,
    vendorId
  }),
  // notes
  getItemNote: ({ itemId }) => ({
    type: constants.GET_ITEM_NOTE.ACTION,
    itemId
  }),
  createItemNote: ({ content, userId, itemId }) => ({
    type: constants.CREATE_ITEM_NOTE.ACTION,
    content,
    userId,
    itemId
  }),
  editItemNote: ({ content, noteId, itemId }) => ({
    type: constants.EDIT_ITEM_NOTE.ACTION,
    content,
    noteId,
    itemId
  }),
  deleteItemNote: ({ noteId, itemId }) => ({
    type: constants.DELETE_ITEM_NOTE.ACTION,
    noteId,
    itemId
  })
}

// Reducer
const initialState = {}

export default createReducer(
  initialState,
  (state, { type, payload, vendorItems, itemsVendors, itemNotes }) => {
    switch (type) {
      default:
        return state
      case constants.GET_ALL_ITEMS.SUCCESS:
        return { ...state, payload }
      case constants.GET_VENDOR_ITEMS.SUCCESS:
        return { ...state, vendorItems }
      case constants.GET_ITEM_VENDORS.SUCCESS:
        return { ...state, itemsVendors }
      case constants.CREATE_NEW_ITEM.SUCCESS:
        return { ...state }
      case constants.DELETE_ITEM_VENDOR.SUCCESS:
        return { ...state }
      case constants.CREATE_NEW_ITEM_VENDOR.SUCCESS:
        return { ...state }
      case constants.UPDATE_SAVED_ITEM.SUCCESS:
        return { ...state }
      case constants.DELETE_ITEM.SUCCESS:
        return { ...state }
      case constants.GET_ITEM_IMAGES.SUCCESS:
        return { ...state, itemImages: payload }
      case constants.SAVE_ITEM_IMAGE.ACTION:
        return { ...state, uploadingImage: true }
      case constants.SAVE_ITEM_IMAGE.SUCCESS:
        return { ...state, uploadingImage: false }
      case constants.SAVE_ITEM_IMAGE.FAIL:
        return { ...state, uploadingImage: false }
      case constants.DELETE_ITEM_IMAGE.ACTION:
        return { ...state, error: null, deletingImage: true }
      case constants.DELETE_ITEM_IMAGE.SUCCESS:
        return {
          ...state,
          deletingImage: false
        }
      // NOTES
      case constants.GET_ITEM_NOTE.SUCCESS:
        return { ...state, itemNotes: itemNotes }

      case constants.CREATE_ITEM_NOTE.ACTION:
        return { ...state }
      case constants.CREATE_ITEM_NOTE.SUCCESS:
        return {
          ...state
        }
      case constants.EDIT_ITEM_NOTE.ACTION:
        return { ...state }
      case constants.EDIT_ITEM_NOTE.SUCCESS:
        return {
          ...state
        }
      case constants.DELETE_ITEM_NOTE.ACTION:
        return { ...state }
      case constants.DELETE_ITEM_NOTE.SUCCESS:
        return {
          ...state
        }
    }
  }
)



// WEBPACK FOOTER //
// ./src/redux/modules/itemsActions.js